module.exports = __webpack_public_path__ + "static/media/advertisers_section2.9cd0c498.png";